import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Theme Store - Dark Mode & Theme Management
 */
export const useThemeStore = create(
  persist(
    (set, get) => ({
      theme: 'light', // 'light', 'dark', 'auto'
      
      // Set theme
      setTheme: (theme) => {
        set({ theme })
        applyTheme(theme)
      },
      
      // Toggle between light and dark
      toggleTheme: () => {
        const current = get().theme
        const newTheme = current === 'light' ? 'dark' : 'light'
        set({ theme: newTheme })
        applyTheme(newTheme)
      },
      
      // Initialize theme on app start
      initTheme: () => {
        const theme = get().theme
        applyTheme(theme)
      }
    }),
    {
      name: 'orion-theme',
    }
  )
)

// Apply theme to document
function applyTheme(theme) {
  const root = document.documentElement
  
  if (theme === 'dark') {
    root.classList.add('dark')
  } else if (theme === 'light') {
    root.classList.remove('dark')
  } else if (theme === 'auto') {
    // Check system preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    if (prefersDark) {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }
  }
}

// Initialize theme on import
if (typeof window !== 'undefined') {
  const store = useThemeStore.getState()
  store.initTheme()
}
